export const FLAGS_VALUES = {
  blocked_retail_signup_utm_campaigns: { isFeatureEnabled: false },
  cms_caching: { isFeatureEnabled: false },
  sme_country_migrate_list: {
    data: [
      'SG',
      'AU',
      'GB',
      'HK',
      'FR',
      'AT',
      'BE',
      'BG',
      'CY',
      'HR',
      'DK',
      'CZ',
      'EE',
      'FI',
      'DE',
      'GR',
      'HU',
      'IS',
      'IE',
      'IT',
      'LV',
      'LI',
      'MT',
      'NL',
      'NO',
      'PL',
      'PT',
      'RO',
      'SK',
      'SI',
      'ES',
      'SE',
      'GB',
      'LT',
      'MC',
      'SM',
      'LU',
      'MY',
      'ID'
    ],
    isFeatureEnabled: true
  },
  advertise_forex_card: { isFeatureEnabled: false },
  advertise_new_payment_methods: { isFeatureEnabled: false },

  app_only_corridors: {
    data: [
      { code: 'JP', name: 'Japan' },
      { code: 'ID', name: 'Indonesia' }
    ],
    isFeatureEnabled: true
  },

  appdownloadpromotion: { isFeatureEnabled: false },

  bene_service_schema_enable_country_currency: {
    data: [
      { country_code: 'BR', currency_code: 'BRL' },
      { country_code: 'AR', currency_code: 'ARS' },
      { country_code: 'JP', currency_code: 'JPY' },
      { country_code: 'CN', currency_code: 'CNY' },
      { country_code: 'PE', currency_code: 'PEN' },
      { country_code: 'CL', currency_code: 'CLP' },
      { country_code: 'CO', currency_code: 'COP' },
      { country_code: 'IN', currency_code: 'INR' },
      { country_code: 'UY', currency_code: 'UYU' },
      { country_code: 'TR', currency_code: 'TRY' },
      { country_code: 'MY', currency_code: 'MYR' },
      { country_code: 'PH', currency_code: 'PHP' },
      { country_code: 'GT', currency_code: 'GTQ' },
      { country_code: 'DO', currency_code: 'DOP' },
      { country_code: 'NG', currency_code: 'NGN' },
      { country_code: 'GH', currency_code: 'GHS' },
      { country_code: 'EG', currency_code: 'EGP' },
      { country_code: 'BT', currency_code: 'USD' },
      { country_code: 'ID', currency_code: 'IDR' }
    ],
    isFeatureEnabled: true
  },

  collect_app_rating: { isFeatureEnabled: false },
  comparison_table: { isFeatureEnabled: false },
  disabled_payment_methods: { data: [], isFeatureEnabled: true },
  feature_discovery_new_payment_method: { isFeatureEnabled: false },
  forex_config: { isFeatureEnabled: false },

  high_value_transaction: {
    data: {
      AU: { AUD: { amount: 30000, enabled: true } },
      SG: {
        SGD: { amount: 30000, enabled: true },
        USD: { amount: 25000, enabled: true }
      },
      HK: {
        HKD: { amount: 150000, enabled: true },
        USD: { amount: 25000, enabled: true }
      },
      US: { USD: { amount: 25000, enabled: true } },
      GB: { GBP: { amount: 20000, enabled: true } },
      EU: { EUR: { amount: 20000, enabled: true } }
    },
    isFeatureEnabled: true
  },

  krisflyer_miles_web: { isFeatureEnabled: false },

  manage_payment_options: {
    data: {
      manage_payment_option_disabled_countries: [],
      credit_card_disabled_countries: ['US'],
      debit_card_disabled_countries: ['US']
    },
    isFeatureEnabled: true
  },

  nium_forex_file_size_limit: { isFeatureEnabled: false },
  non_hard_migrated_sme_flow: { isFeatureEnabled: false },
  payto_banner: { isFeatureEnabled: false },
  recurring_transfer: {
    data: {
      isBestRateEnabled: true
    },
    isFeatureEnabled: true
  },
  show_fee_difference: { isFeatureEnabled: false },

  thb_supported_banks: {
    data: [
      'Bangkok Bank Public Company Limited',
      'Kasikornbank Public Company Limited',
      'Krung Thai Bank Public Co Limited',
      'The Siam Commercial Bank Public Company Limited',
      'CIMB Thai Bank Public Company Limited',
      'Bank of Ayudhya Public Company Limited',
      'Kiatnakin Bank Public Company Ltd'
    ],
    isFeatureEnabled: true
  },

  is_cooling_off_period_feature_enabled: { data: null, isFeatureEnabled: true },
  onboarding_rating: { isFeatureEnabled: false },
  promotions_tab_enabled: { isFeatureEnabled: false },

  new_coupon_flow: { isFeatureEnabled: false },
  collect_bank_account_type: { data: { MY: ['EGHL'] }, isFeatureEnabled: true },

  fatzebra_loader: { data: { delay: 10000 }, isFeatureEnabled: true },
  apple_pay_config: {
    data: {
      enabledUsers: [],
      delayInMs: 8000
    },
    isFeatureEnabled: true
  },
  beneficiary_flow_payout_methods: { isFeatureEnabled: false },
  dha_challan: { isFeatureEnabled: true },
  uniform_referral_countries: { data: ['SG'], isFeatureEnabled: false }
};
